// components/ProductLabels.tsx

import { StickerFragment } from '@/graphql';
import React from 'react';
import IconArrowDown from '@/assets/icons/category/icon-arrow-down.svg';
import styles from '../styles.module.scss';
import Link from 'next/link';
import { decodeBase64Id } from '@/helpers/decodeBase64Id';
import Image from 'next/image';
import DefaultProductPlaceholder from '@/assets/images/Yellow.png';
import AvailabilityIndicator from '../../availabilityIndicator';
import convertToReadable from '@/helpers/convertToReadable';
import { useTranslations } from 'next-intl';
import { ProductLabelsProps } from '@/types/categoryCard-types';

export const ProductLabels = ({
  labels,
  bonus,
  discount,
  id,
  slug,
  addToVariant,
  showAllLabels,
  topSectionHeight,
  handleToggleLabels,
  visibleLabels,
  showToggleButton,
  image,
  productType,
  title,
  pricePerMonth,
  availability,
}: ProductLabelsProps) => {
  const t = useTranslations('General');
  return (
    <>
      <Link
        href={id && slug ? `/product/${decodeBase64Id(id)}-${slug}` : '#'}
        onClick={() => addToVariant(id)}
      >
        <div className={styles.topContent}>
          {(labels ?? []).length > 0 ||
          (bonus !== undefined && bonus !== null && bonus !== 0) ||
          discount ? (
            <>
              {' '}
              {showAllLabels && (
                <div style={{ height: `${topSectionHeight}px` }}></div>
              )}
              <div
                className={`${styles.topSection} ${showAllLabels ? styles.topSectionExpanded : ''}`}
              >
                {visibleLabels?.map((label: any) => (
                  <div
                    className={styles.dates}
                    style={{
                      backgroundColor: `${label.backgroundColor}`,
                      color: `${label.color}`,
                    }}
                    key={label.id}
                  >
                    {label.name}
                  </div>
                ))}
                {bonus !== undefined && bonus !== null && bonus !== 0 && (
                  <div className={styles.bonus}>{t('bonus')}</div>
                )}
                {discount !== 0 && (
                  <div className={styles.disc}>{t('discount')}</div>
                )}
                {showToggleButton && (
                  <button
                    type="button"
                    className={styles.dropdown}
                    onClick={e => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleToggleLabels();
                    }}
                  >
                    <IconArrowDown />
                  </button>
                )}
              </div>
            </>
          ) : (
            <div style={{ height: `24px` }}></div>
          )}
          <div className={styles.cardImage}>
            <Image
              src={image ? image : DefaultProductPlaceholder}
              alt={'card-image'}
              width={200}
              height={140}
              style={{ objectFit: 'contain' }}
            />
          </div>
          <div className={styles.caption}>{productType}</div>
          <p className={styles.title}>{title}</p>
          {pricePerMonth !== undefined &&
            pricePerMonth !== null &&
            pricePerMonth !== 0 && (
              <div className={styles.fromPrice}>
                {t('from')} {convertToReadable(Math.round(pricePerMonth / 12))}{' '}
                {t('price-month')}
              </div>
            )}
          {availability && (
            <AvailabilityIndicator availability={availability} />
          )}
        </div>
      </Link>
    </>
  );
};
